import { FC } from 'react';
import { default as ReactRating, RatingComponentProps } from 'react-rating';
import { IoStarOutline } from '@react-icons/all-files/io5/IoStarOutline';
import { IoStar } from '@react-icons/all-files/io5/IoStar';
import { Icon, IconProps } from '@chakra-ui/react';

type RatingProps = RatingComponentProps & {
  iconProps?: IconProps;
};

export const Rating: FC<RatingProps> = ({ iconProps, ...props }) => {
  return (
    <ReactRating
      emptySymbol={<Icon as={IoStarOutline} {...iconProps} />}
      fullSymbol={<Icon as={IoStar} {...iconProps} />}
      {...props}
    />
  );
};
